import React from 'react';

// import { SignInButton } from '../auth/SignInButton';
import { SignOutButton } from '../auth/SignoutButton';
import { SignUpSignInButton } from '../auth/SignUpSignInButton';

export default function ProfileMenuItem(props) {

  return (
    props.isAuthenticated ? (
      <SignOutButton label="Logout"></SignOutButton>
    ) : (
      <SignUpSignInButton label="Login"></SignUpSignInButton>
    ));
}